import { ImageGallery } from "@/@types/ui/ImageGallery";
import { ROUTES } from "@/config/routes";

export function transformProductImageGallery(data: any[]): ImageGallery[] {
  if (!Array.isArray(data) || data.length === 0) {
    return [];
  }

  return data.map((imageMedia) => ({
    src: imageMedia.local || imageMedia.media_url || imageMedia.media,
  }));
}